import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      animation: `$slideIn 300ms ${theme.transitions.easing.easeInOut}`,
    },

    "@keyframes slideIn": {
      "0%": {
        opacity: 0,
        transform: "translateX(10%)",
      },
      "100%": {
        opacity: 1,
        transform: "translateX(0)",
      },
    },
  }),
  {
    name: "slide-wrapper-style",
    flip: null,
  }
);
